// ------------------------------------
// Constants
// ------------------------------------
export const THREAT_PREVENTION_PROFILES_GET_REQUEST = "THREAT_PREVENTION_PROFILES_GET_REQUEST";
export const THREAT_PREVENTION_PROFILES_GET_REQUEST_SUCCESS = "THREAT_PREVENTION_PROFILES_GET_REQUEST_SUCCESS";
export const THREAT_PREVENTION_PROFILES_GET_REQUEST_FAILURE = "THREAT_PREVENTION_PROFILES_GET_REQUEST_FAILURE";

export interface ThreatPreventionProfilesPayload {
  search?: string;
}
